import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';

import s from './AboutFirst.css';
import cs from '../../commonStyle.css';
import cx from 'classnames';
import messages from '../../../locale/messages';

class AboutFirst extends Component {
  render() {
    const { title, content , title2, content2} = this.props;

    return (
      <>
        <div className={cx(s.aboutFirst)}>
          <div className={cx(s.container)}>
            <div className={cx(s.aboutContainer)}>
              <div className={cx(s.aboutImage)} style={{ backgroundColor: '#0C3C640A' }}></div>
              <div className={cx(s.aboutContent)}>
                <div className={cx(s.contentTitle)}>
                  <h1 className={cx(s.title, s.iconTitle)}>
                    {/* <FormattedMessage {...messages.aboutMotostream} /> */}
                    {title}
                  </h1>
                </div>
                <p className={cx(s.subTitle)}>
                    {/* <FormattedMessage {...messages.aboutSubtitle} /> */}
                    {content}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={cx(s.mission)}>
          <div className={cx(s.container)}>
            <div className={cx(s.aboutContainer)}>
              <div className={cx(s.missionImage)} style={{ backgroundColor: '#FB8C5414' }}></div>
              <div className={cx(s.missionContent)}>
                <div className={cx(s.contentTitle)}>
                  <h1 className={cx(s.title, s.iconTitleSecond)}>
                    {title2}
                  </h1>
                </div>
                <p className={cx(s.subTitle, s.margin)}>
                  {content2}
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withStyles(s, cs)(AboutFirst);